<template>
  <div id="app">
    <HeaderV2 />
    <router-view />
    <FooterV2 />
  </div>
</template>

<script>
import HeaderV2 from '@/components/HeaderV2.vue'
import FooterV2 from '@/components/FooterV2.vue'

export default {
  name: 'App',
  components: {
    HeaderV2,
    FooterV2
  }
}
</script>

<style lang="scss">
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
</style>
